<script setup lang="ts">
import StaticSuggestedActivitiesBannerLoader from '../upsell/StaticSuggestedActivitiesBannerLoader.vue';
</script>

<template>
  <div class="static-activity-loader">
    <StaticSuggestedActivitiesBannerLoader />
  </div>
</template>

<style lang="scss" scoped>
.static-activity-loader {
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  z-index: 0;
  &::after {
    content: '';
    height: 100%;
    width: 0px;
    border-right: 1px dashed var(--color-neutral-70);
    position: absolute;
    top: 0;
    left: 49px;
    z-index: 1;

    @include for-less-or-equal-than-599-px {
      left: 37px;
    }
  }
}
</style>
